module.exports = __webpack_public_path__ + "static/media/sanisidro.71e728cd.PNG";